<!--
 * A Vue component for showing a tooltip
 *
 *
 * Properties
 * ==========
 * - target -
 * (Optional) The target is the trigger element (or component) that will trigger the tooltip.
 *
 * - title -
 *  (Optional) Tooltip content.
 *
 * Usage
 * ==========
 * - You can add extra attributes from the parent component
-->
<template>
    <div>
        <b-tooltip
            :target="target"
            triggers="hover focus click"
            :show.sync="showTooltip"
            @shown="hideTooltipLater"
            :title="title"
            :custom-class="customClass"
        >
        </b-tooltip>
    </div>
</template>

<script>
    export default {
        name: 'Tooltip',
        inheritAttrs: false,

        props: {
            target: { type: String, required: false, default: 'bv-info-btn' },
            title: { type: String, required: false, default: '' },
            customClass: { type: String, required: false, default: '' },
            timeOut: { type: Number, required: false, default: 3000 }
        },

        data() {
            return {
                showTooltip: false,
                timeout: null
            };
        },

        methods: {
            hideTooltipLater() {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(() => {
                    this.showTooltip = false;
                }, this.timeOut);
            }
        }
    };
</script>

<style>
.tooltip {
    font-family: inherit;
    font-size: inherit;
}

.tooltip.b-tooltip {
    opacity: 1;
}

.tooltip.xlarge .tooltip-inner {
    max-width: 450px;
}

.tooltip.large .tooltip-inner {
    max-width: 400px;
}

.tooltip.medium .tooltip-inner {
    max-width: 350px;
}
</style>
